import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { detect } from 'detect-browser';

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.css']
})
export class MenuNavComponent implements OnInit {
  isIndex = false;
  isNotIndex = false;
  RouteText : any;
  notas!: any[];
  newstr: any;
  activo : any;
  btnMovil : any;
  btnMovilOpen : any;
  noworkingIE = false;
  ocul = false;
  nav: any;

  constructor(private router: Router ) {

    this.router.events.subscribe(value => {
      this.RouteText=router.url.toString();

      if(this.RouteText != "/"){
        this.isIndex = true;
        this.isNotIndex = false;
    
      }else{
        this.isIndex = true;
        this.isNotIndex = false;
      }
    
    });

    const browser = detect();
    if (browser) {
      this.nav = browser.name;
    }


    if (this.nav == 'ie') {
      this.noworkingIE = true;
      this.ocul = false;
    } else {
      this.noworkingIE = false;
      this.ocul = true;
    }
  }



  getNotaUrl(nota: any) {
    this.newstr = nota.urlNota.toLowerCase();
    this.newstr = this.newstr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    this.router.navigate(["/nota/" + nota.id + "/" + this.newstr]);
    // por si se necesita remplazar caractes especiales
    // this.newstr = this.newstr.replace(/[^\w\s]/gi, '');
}
  getAll(){
    this.router.navigate(['notas']);
  }
  ngOnInit(): void {

  }
}
